import {
  FirmDetailMasterActions,
  firmConstitutionActions,
  getFirmDetailsAction,
  getFirmPanDetailsAction,
  HeadOfficeActions,
  getFirmAccountNumberDetailsAction,
} from "./addFirmdetailsAction";

const initialState = {
  accountTypeList: [],
  companyTypeList: [],
  constitutionList: [],
  countriesList: [],
  noOfEmployeesList: [],
  officeInLocalityList: [],
  officeOwnershipList: [],
  pincodesList: [],
  HeadOfficeDetails: {},
  firmConstitution: {},
  firmDetails: {},
  firmPanDetails: {},
  firmAccountNumber: {},
  error: "",
};

const firmDetailMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FirmDetailMasterActions.FIRM_DETAIL_MASTER_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case firmConstitutionActions.FIRM_CONSTITUTION_SUCCESS:
      return {
        ...state,
        firmConstitution: action.payload,
      };

    case getFirmDetailsAction.GET_FIRM_DETAIL_SUCCESS:
      return {
        ...state,
        firmDetails: action.payload,
      };

    case getFirmPanDetailsAction.GET_FIRM_PAN_DETAIL_SUCCESS:
      return {
        ...state,
        firmPanDetails: action.payload,
      };
    case getFirmPanDetailsAction.GET_FIRM_PAN_DETAIL_ERROR:
      return {
        ...state,
        firmPanDetails: "",
        error: action.payload,
      };

    case HeadOfficeActions.HEAD_OFFICE_SUCCESS:
      return {
        ...state,
        HeadOfficeDetails: action.payload,
      };

    case getFirmAccountNumberDetailsAction.GET_FIRM_ACCOUNTNUMBER_DETAIL_SUCCESS:
      return {
        ...state,
        firmAccountNumber: action.payload,
      };

    default:
      return state;
  }
};

export default firmDetailMasterReducer;
